import { render } from "./TopBarSkeleton.vue?vue&type=template&id=00a613de&scoped=true"
const script = {}

import "./TopBarSkeleton.vue?vue&type=style&index=0&id=00a613de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a613de"]])

export default __exports__